import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import TopoSemMenu from "../../components/TopoSemMenu";
import FormPrimeiroAcesso from "./components/FormPrimeiroAcesso";

class PrimeiroAcesso extends React.Component {
  render() {
    return (
      <div>
        <TopoSemMenu />
        <Switch>
          <Route
            exact
            path="/primeiro-acesso/:email"
            component={() => <FormPrimeiroAcesso />}
          />
        </Switch>
      </div>
    );
  }
}

export default withRouter(PrimeiroAcesso);
